(function () {
    'use strict';

    const filterBtns = document.querySelectorAll('.filter-btn');
    const workCards = document.querySelectorAll('.work-card');
    const featuredGrid = document.getElementById('featured-grid');
    const regularGrid = document.getElementById('regular-grid');
    const noResults = document.getElementById('no-results');
    const filtersPanel = document.getElementById('work-filters');
    const filtersBackdrop = document.getElementById('work-filters-backdrop');
    const filtersOpenBtn = document.getElementById('work-filters-open');
    const filtersCloseBtn = document.getElementById('work-filters-close');
    const filterLabel = document.getElementById('work-filter-label');
    const desktopQuery = window.matchMedia('(min-width: 1024px)');

    if (!filterBtns.length || !workCards.length) return;

    // ── Active style tokens ──────────────────────────────────────────────────
    const ACTIVE_CLASSES = ['text-navy', 'font-semibold'];
    const INACTIVE_CLASSES = ['text-navy/60', 'font-normal'];

    function isDesktop() {
        return desktopQuery.matches;
    }

    function setPanelOpen(open) {
        if (!filtersPanel || isDesktop()) return;

        filtersPanel.classList.toggle('is-open', open);
        filtersPanel.setAttribute('aria-hidden', open ? 'false' : 'true');

        if (filtersBackdrop) {
            filtersBackdrop.classList.toggle('is-open', open);
            filtersBackdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        if (filtersOpenBtn) {
            filtersOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        document.body.style.overflow = open ? 'hidden' : '';
    }

    function openPanel() {
        setPanelOpen(true);
        requestAnimationFrame(() => {
            if (filtersCloseBtn) filtersCloseBtn.focus();
        });
    }

    function closePanel() {
        setPanelOpen(false);
        if (filtersOpenBtn) filtersOpenBtn.focus();
    }

    function syncPanelForViewport() {
        if (!filtersPanel) return;

        if (isDesktop()) {
            filtersPanel.classList.remove('is-open');
            filtersPanel.setAttribute('aria-hidden', 'false');
            if (filtersBackdrop) {
                filtersBackdrop.classList.remove('is-open');
                filtersBackdrop.setAttribute('aria-hidden', 'true');
            }
            if (filtersOpenBtn) filtersOpenBtn.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        } else if (!filtersPanel.classList.contains('is-open')) {
            filtersPanel.setAttribute('aria-hidden', 'true');
            if (filtersBackdrop) filtersBackdrop.setAttribute('aria-hidden', 'true');
        }
    }

    function updateFilterLabel(btn) {
        if (!filterLabel || !btn) return;
        filterLabel.textContent = btn.textContent.trim();
    }

    function setActiveBtn(target) {
        filterBtns.forEach(btn => {
            const isTarget = btn === target;
            btn.setAttribute('aria-pressed', isTarget ? 'true' : 'false');
            ACTIVE_CLASSES.forEach(c => btn.classList.toggle(c, isTarget));
            INACTIVE_CLASSES.forEach(c => btn.classList.toggle(c, !isTarget));
        });
        updateFilterLabel(target);
    }

    // ── Filter logic ─────────────────────────────────────────────────────────
    function applyFilter(filterType, filterId) {
        const isAll = filterType === 'all';
        let visibleCount = 0;

        workCards.forEach(card => {
            let show = false;

            if (isAll) {
                show = true;
            } else {
                const sectorIds = card.dataset.sectors ? card.dataset.sectors.split(',') : [];
                const serviceIds = card.dataset.services ? card.dataset.services.split(',') : [];

                show = filterType === 'sector'
                    ? sectorIds.includes(filterId)
                    : serviceIds.includes(filterId);
            }

            card.style.display = show ? '' : 'none';
            if (show) visibleCount++;
        });

        if (isAll) {
            restoreFeaturedGrid();
        } else {
            collapseFeaturedGrid();
        }

        noResults.classList.toggle('hidden', visibleCount > 0);
    }

    function collapseFeaturedGrid() {
        if (!featuredGrid) return;
        featuredGrid.style.display = 'none';

        const featured = featuredGrid.querySelectorAll('.work-card');
        featured.forEach(card => {
            if (!regularGrid.contains(card)) {
                regularGrid.prepend(card);
            }
        });
    }

    function restoreFeaturedGrid() {
        if (!featuredGrid) return;
        featuredGrid.style.display = '';

        const featured = regularGrid.querySelectorAll('.work-card[data-featured="true"]');
        featured.forEach(card => featuredGrid.appendChild(card));
    }

    // ── Event listeners ──────────────────────────────────────────────────────
    filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const filterType = btn.dataset.filter;
            const filterId = btn.dataset.id ?? null;

            setActiveBtn(btn);
            applyFilter(filterType, filterId);

            if (!isDesktop()) closePanel();
        });
    });

    if (filtersOpenBtn) {
        filtersOpenBtn.addEventListener('click', openPanel);
    }

    if (filtersCloseBtn) {
        filtersCloseBtn.addEventListener('click', closePanel);
    }

    if (filtersBackdrop) {
        filtersBackdrop.addEventListener('click', closePanel);
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && filtersPanel?.classList.contains('is-open')) {
            closePanel();
        }
    });

    desktopQuery.addEventListener('change', syncPanelForViewport);

    // ── Init ─────────────────────────────────────────────────────────────────
    const allBtn = document.querySelector('.filter-btn[data-filter="all"]');
    if (allBtn) setActiveBtn(allBtn);
    syncPanelForViewport();
})();
